<template>
<div>
    <v-row>
        <v-col>
            <v-card style="height:80vh; overflow: auto;">
                <v-card-title class="table-header">
                    <v-row align="center">
                        Hier ist Ihre generierte Umfrage. Prüfen Sie die Fragen und senden Sie die Umfrage ab.
                    </v-row>
                </v-card-title>
                <v-main style="margin:5px; padding: 0;">
                  <PXSurvey :schema="schema" :displayMode="'display'"/>
                </v-main>
            </v-card>
        </v-col>
    </v-row>
    <v-row>
        <v-col style="padding:0; margin: 0">
          <v-btn color="primary" class="bottomButton" @click="cancel()">Abbrechen</v-btn> 
        </v-col>
        <v-col style="padding:0">
          <v-btn color="primary" class="bottomButton" @click="submitSurvey()">Umfrage erstellen</v-btn> 
        </v-col>
    </v-row>
  </div>
</template>

<script>
import PXSurvey from "@/components/common/PXSurvey.vue"
import surveyGenerator from '@/components/px-survey-generator'
import pxSurveyService from "./px-survey-service"
export default {
  data: () => ({
    schema: {},
    surveyTitle: ""
  }),
  components: {
    PXSurvey
  },
  watch: {
  },
  mounted() {
      this.schema = this.$route.params.schema;
      this.surveyTitle = this.$route.params.surveyTitle;
      this.selectedModule = this.$route.params.selectedModule;
      
  },
  methods: {
      submitSurvey(){
          pxSurveyService.savePXSurvey(this.schema, this.selectedModule).then(() => 
            this.$router.push('/surveys')
          )
      },
      cancel(){
        this.$router.go(-1)
      }
  },
};
</script>
<style scoped>
.frame{
    border: 1px solid lightgray;
    margin:5px;
}
.row{
    margin:5px;
}
.filter{
    width:10%;
    float:right;
    margin-right: 10px;
}
.table-header{
    padding:0 !important
}
.bottomButton{
    width: calc(100% - 20px);
    margin:0px 10px;
}

</style>